module.exports = __webpack_public_path__ + "static/ogp-3a85c493108622fd755cb8dafd5b278b.png";